export const PACKAGE_STATUS_LABELS = {
    0: 'Not Started',
    10: 'Start pending',
    20: 'Started',
    30: 'Stop pending',
    40: 'Stopped',
    70: 'Creating reports',
    90: 'Partially completed',
    100: 'Completed',
    110: 'Failed',
    120: 'Failed',
    130: 'Failed',
    140: 'Failed',
    170: 'Failed',
    180: 'Failed',
    190: 'Failed',
    200: 'Failed',
    210: 'Failed',
    220: 'Failed',
    230: 'Failed',
    240: 'Failed',
    404: 'Deleted',
}